import { Moon, Sun } from '@phosphor-icons/react';
import { useImmoTheme, type ImmoTheme } from '../../../lib/immobilien/theme';

/** Hell/Dunkel als Zweier-Schalter (Sidebar im Listenmodus, README §5.6). */
export function ThemeUmschalter({ kompakt = false }: { kompakt?: boolean }) {
  const [theme, setTheme] = useImmoTheme();
  const knopf = (wert: ImmoTheme, label: string, IconKomp: typeof Sun) => {
    const an = theme === wert;
    return (
      <button
        type="button"
        aria-label={label}
        data-tip={`${wert === 'light' ? 'Helles' : 'Dunkles'} Design – Darstellung umschalten`}
        aria-pressed={an}
        onClick={() => setTheme(wert)}
        className="flex items-center justify-center cursor-pointer"
        style={{
          flex: 1, minWidth: 32, height: 30, border: 'none', borderRadius: 11, gap: 6, fontSize: 12, fontWeight: 700,
          background: an ? 'var(--acc-fill)' : 'transparent', color: an ? 'var(--acc-ink)' : 'var(--ink2)',
        }}
      >
        <IconKomp weight="fill" size={15} />
        {!kompakt && <span>{label}</span>}
      </button>
    );
  };
  return (
    <div role="group" aria-label="Darstellung" className="flex flex-wrap" style={{ gap: 4, padding: 3, borderRadius: 14, background: 'var(--fill2)' }}>
      {knopf('light', 'Hell', Sun)}
      {knopf('dark', 'Dunkel', Moon)}
    </div>
  );
}

/** Einzelnes Icon zum Umschalten (Icon-Leiste der Sidebar im Objektmodus). */
export function ThemeIconKnopf() {
  const [theme, setTheme] = useImmoTheme();
  const IconKomp = theme === 'dark' ? Sun : Moon;
  return (
    <button
      type="button"
      aria-label={theme === 'dark' ? 'Hell darstellen' : 'Dunkel darstellen'}
      data-tip={theme === 'dark' ? 'Helles Design – Darstellung umschalten' : 'Dunkles Design – Darstellung umschalten'}
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      className="immo-hover-flaeche flex items-center justify-center cursor-pointer"
      style={{ width: 32, height: 32, borderRadius: 10, border: 'none', background: 'transparent' }}
    >
      <IconKomp weight="fill" size={17} color="var(--ink2)" />
    </button>
  );
}
